export default __webpack_public_path__ + "static/walgreens-8d4c7e0bb16a25904f8a617e002db47b.svg";